import type { Chart, Options } from 'highcharts/highstock';

export class ChartRuntimeElement extends HTMLElement {

    private chart: Chart;

    static get observedAttributes() {
        return ['options'];
    }

    public disconnectedCallback(): void {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    public attributeChangedCallback(name: string, prevValue: string, value: string): void {
        if (!ChartRuntimeElement.observedAttributes.includes(name)) {
            return;
        }
        if (prevValue !== value && value) {
            console.log(`Attribute "${name}" changed.`, value);
            if (value.startsWith('script-')) {
                const scriptTag: HTMLElement = document.getElementById(value);
                if (scriptTag) {
                    try {
                        const parsed: Options = JSON.parse(scriptTag.textContent) as Options;
                        if (document.readyState === 'loading') {
                            document.addEventListener('DOMContentLoaded', () => this.draw(parsed));
                          } else {
                            this.draw(parsed);
                          }
                    } catch (error) {
                        console.error('[Chart] Unable to parse chart options.', error);
                    }
                }
            }
        }
    }

    public draw(options: Options): void {
        setTimeout(async () => {
            const highcharts = (await import('./chart-startup')).default;
            this.chart = highcharts.chart(this, options);
        }, 1000);
    }
}
